import { useState } from "react";
import { MessageSquareText } from "lucide-react";
import { VoiceDemo } from "@/components/VoiceDemo";
import { ConciergeHero, DemoSection } from "@/components/ConciergeDemo";

export default function PreviewHero() {
  const [voiceOpen, setVoiceOpen] = useState(false);
  return (
    <div className="bg-sand-50 min-h-screen scroll-smooth">
      <div className="bg-ink text-white text-center text-xs py-2 font-semibold tracking-wide">PREVIEW. Nothing on the live site has changed.</div>

      <nav className="sticky top-0 z-40 bg-sand-50/85 backdrop-blur-xl border-b border-sand-100">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2"><div className="h-8 w-8 rounded-xl bg-redline-500 flex items-center justify-center"><MessageSquareText className="h-4 w-4 text-white" /></div><span className="font-heading font-extrabold">Ask Redline</span></div>
          <a href="#demo" className="rounded-full bg-redline-500 text-white text-sm font-bold px-5 py-2.5 hover:bg-redline-600 transition-colors">Book a demo</a>
        </div>
      </nav>

      <ConciergeHero onVoice={() => setVoiceOpen(true)} ctaAttrs={{ href: "#demo" }} />

      {/* UNIFIED TRUST BAR */}
      <section className="bg-ink py-6">
        <div className="max-w-6xl mx-auto px-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
          {["Grounded in your documents", "TCPA aware", "Audit logged", "No app for residents", "Live in about a week"].map((t, i) => (
            <span key={t} className="flex items-center gap-4 text-[11px] font-bold uppercase tracking-[0.2em] text-sand-300">
              {i > 0 && <span className="text-sand-500">&bull;</span>} {t}
            </span>
          ))}
        </div>
      </section>

      <DemoSection onVoice={() => setVoiceOpen(true)} />

      <VoiceDemo open={voiceOpen} onClose={() => setVoiceOpen(false)} />
    </div>
  );
}
